import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'n7-tap-on-map',
  templateUrl: './n7-tap-on-map.component.html',
  styleUrls: ['./n7-tap-on-map.component.scss'],
})
export class N7TapOnMapComponent implements OnInit {

  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() {}

  gotIt() {
    this.popoverController.dismiss();
  }
}
